import React, { useMemo, useState, useEffect, useRef } from 'react';
import { useZone } from '../../../../hooks/zone';
import './ZoneViewMenuLayoutByCategory.scss';
import { MenuProductCard } from '../../../menu-product/card/MenuProductCard';
import groupBy from 'lodash/groupBy';
import { MenuProduct } from '../../../../XV2';
import { ZoneViewActiveOrder } from '../../active-order/ZoneViewActiveOrder';
import { useMenuProductCategory } from '../../../../hooks/menu-product-category';
import { MenuProductCategoryScroller } from '../../../menu-product/category-scroller/MenuProductCategoryScroller';
import clsx from 'clsx';
import { useLayoutFooter } from '../../../../hooks/useLayoutFooter';
import { startCase } from '../../../../util/startCase';
import { stringIncludes } from '../../../../util/stringIncludes';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';
import { XSSection } from '../../../../xs/component/section/XSSection';

export function ZoneViewMenuLayoutByCategory() {
    useLayoutFooter().useHidePlaceholderOnCurrentPage();
    const zone = useZone();
    const menuProductCategory = useMenuProductCategory();
    const [keyword] = useState('');
    const [_activeCategory, setActiveCategory] = useState<string>();
    const [scrollTop, setScrollTop] = useState(0);
    const virtuoso = useRef<VirtuosoHandle>(null);

    const headerHeight = 48;
    const categoryScrollerHeight = 40;
    const anchorOffset = headerHeight + categoryScrollerHeight;

    const { list, categories } = useMemo(() => {
        const menuProductsByCategory = groupBy(zone.menuProducts, (menuProduct) => menuProduct.product.subCategory);

        const list: any[] = [];
        const categories: string[] = [];

        Object.keys(menuProductsByCategory).forEach((category) => {
            categories.push(category);

            list.push({
                rowType: 'CATEGORY',
                rowHeight: 58 + 8,
                category: category,
            });

            list.push(
                ...menuProductsByCategory[category].map((menuProduct) => {
                    const isLarge =
                        menuProduct.product.description?.length > 40 ||
                        menuProduct.product.icon?.includes?.('https://');

                    return {
                        rowType: 'MENU_PRODUCT',
                        rowHeight: (isLarge ? 98 : 58) + 8,
                        ...menuProduct,
                    };
                }),
            );
        });

        return {
            list: [...list, undefined].filter((item) => {
                if (!keyword) {
                    return true;
                }

                return stringIncludes(item?.product?.name, keyword);
            }),
            categories,
        };
    }, [zone.menuProducts, keyword]);

    useEffect(() => {
        const firstCategory = list.find((item) => item.category)?.category;

        let targetHeight = 0;
        let targetCategory;

        list.forEach((item) => {
            if (targetHeight <= scrollTop) {
                targetHeight += item.rowHeight;

                if (item.category) {
                    targetCategory = item.category;
                }
            }
        });

        setActiveCategory(targetCategory || firstCategory);
    }, [scrollTop, list]);

    const activeCategory = _activeCategory ?? categories[0];

    if (menuProductCategory.isMyOrderActive()) {
        return <ZoneViewActiveOrder />;
    }

    return (
        <div className={'ZoneViewMenuLayoutByCategory'}>
            <div className={'scroller-container'}>
                <MenuProductCategoryScroller
                    categories={categories}
                    type={'SUB_CATEGORY'}
                    isAnchorLinks={false}
                    anchorOffset={anchorOffset}
                    activeCategory={keyword ? undefined : activeCategory}
                    onChange={(category) => {
                        const index = list.indexOf(list.find((item) => item.category === category));

                        virtuoso.current?.scrollToIndex({
                            index: index + 1,
                            align: 'start',
                            behavior: 'smooth',
                        });

                        //document.querySelector('.ReactVirtualized__List')?.scrollTo({
                        //    top: sum(list.slice(0, index).map((item) => item.rowHeight)),
                        //    behavior: 'smooth',
                        //});
                    }}
                />
            </div>

            {/*<XSection>*/}
            {/*    <XInput*/}
            {/*        value={keyword}*/}
            {/*        onChangeValue={setKeyword}*/}
            {/*        placeholder="Search for product"*/}
            {/*        iconStart="search"*/}
            {/*        clearable*/}
            {/*    />*/}
            {/*</XSection>*/}

            <div className={'products-container'}>
                <Virtuoso
                    ref={virtuoso}
                    data={list}
                    itemContent={(index, item) => {
                        const isMenuProduct = Boolean(item?.product);

                        return (
                            <div
                                className={clsx('menu-product-container', { isMenuProduct })}
                                style={{ marginBottom: 8 }}>
                                {item?.rowType === 'CATEGORY' && <XSSection>{startCase(item.category)}</XSSection>}

                                {item?.rowType === 'MENU_PRODUCT' && (
                                    <MenuProductCard menuProduct={item as MenuProduct} />
                                )}
                            </div>
                        );
                    }}
                    onScroll={(item) => {
                        setScrollTop((item.nativeEvent.target as any).scrollTop);
                    }}
                />
            </div>
        </div>
    );
}
